<template>
  <f7-popup :id="nameId" @popup:open="setServices" style="overflow: hidden;">
    <page-nav-bar
      subNavTitle="MoneyRoad Services"
      :closePopup="closeButton"
      :isLeftPanel="true"
      :notReturnButton="true"
      :picker="false"
      :switchService="true">
    </page-nav-bar>
    <f7-block>
        <row-grid-menu class="menuChangeService" :marginValue="marginvalue">
          <menu-item v-if="'service-disabled' === '0'"
            slot="leftCol"
            icon="payments-grey"
            label="Request to Pay"
            :labelStyle="{size: '12', color: 'grey'}"
            :labelIcon="getServiceStatus(services.payments.active)">
          </menu-item>
          <menu-item v-else
            slot="leftCol"
            :link="(userIsGuest()) ? '/inbox/0' : '/dashboard/'"
            icon="payments"
            :service="true"
            label="Request to Pay"
            :labelStyle="{size: '12', color: 'black'}"
            :clickAction="{name: 'changeService', value: services.payments}"
            :closePopup="true"
            :labelIcon="getServiceStatus(services.payments.active)">
            <f7-link
              class="serviceList"
              id="enrollButton"
              @click="enroll()">
              {{getActiveStatus(services.payments.active)}}
            </f7-link>
          </menu-item>
          <menu-item v-if="'service-disabled' === '0'"
            slot="rightCol"
            icon="exchangedoc-grey"
            label="Direct Payments"
            :labelStyle="{size: '12', color: 'grey'}">
          </menu-item>
          <menu-item v-else
            slot="rightCol"
            :link="(userIsGuest()) ? '/directPayments/inbox/' : 'directPayments/dashboard/'"
            icon="exchangedoc"
            :service="true"
            label="Direct Payments"
            :labelStyle="{size: '12', color: 'black'}"
            :clickAction="{name: 'changeService', value: services.directPayments}"
            :closePopup="true">
            <f7-link
              class="serviceList"
              id="enrollButton"
              @click="enroll()">
              {{getActiveStatus(services.directPayments.active)}}
            </f7-link>
          </menu-item>
        </row-grid-menu>
        <row-grid-menu :marginValue="marginvalue">
          <menu-item v-if="'service-disabled' === '0'"
            slot="leftCol"
            icon="sepa-grey"
            label="Modular Loan"
            :labelStyle="{size: '12', color: 'grey'}"
            :labelIcon="getServiceStatus(services.directDebit.active)">
          </menu-item>
          <menu-item v-else
            slot="leftCol"
            :link="(userIsGuest()) ? '/directDebit/inbox/' : '/directDebit/dashboard/'"
            :service="true"
            icon="sepa"
            label="Modular Loan"
            :labelStyle="{size: '12', color: 'black'}"
            :clickAction="{name: 'changeService', value: services.directDebit}"
            :closePopup="true"
            :labelIcon="getServiceStatus(services.directDebit.active)">
            <f7-link
              class="serviceList"
              id="enrollButton"
              @click="enroll()">
              {{getActiveStatus(services.directDebit.active)}}
            </f7-link>
          </menu-item>
          <!-- TLV 09/03/2020 : Nouveau service, pour l'instant grisé.
              L'icône sepa-grey est temporaire, Sara devrait faire la nouvelle icône. -->
          <menu-item
            slot="rightCol"
            icon="invoicedirect-grey"
            :label="DirectInvoiceLabel"
            :labelStyle="{size: '12', color: 'grey'}"
            :clickAction="{name: 'doNothing', value: ''}">
          </menu-item>
        </row-grid-menu>
    </f7-block>
  </f7-popup>
</template>

<script>
import rowGridMenu from '@/components/common/rowGridMenu.vue'
import menuItem from '@/components/common/menuItem.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'service-switcher',
  components: {
    'row-grid-menu': rowGridMenu,
    'menu-item': menuItem,
    'page-nav-bar': pageNavBar
  },
  props: {
    closeButton: Boolean
  },
  data: () => {
    return {
      services: {
        payments: {},
        directDebit: {},
        directPayments: {},
        exchangeDoc: {},
        rubis: {},
        diamond: {},
        nameId: 'service-switcher-true'
      },
      /* TLV 09/03/2020
      * @brief Centrage des items sur le menu de changement de service
      * (plus la valeur de marginvalue est élevée, plus les items convergent au centre) */
      marginvalue: 35
    }
  },
  created () {
    this.nameId = 'service-switcher-' + this.closeButton
    this.DirectInvoiceLabel = this.$i18n.t('servicesNames.direct_invoice_name')
  },
  updated () {
    this.nameId = 'service-switcher-' + this.closeButton
  },
  mounted () {
    this.nameId = 'service-switcher-' + this.closeButton
  },
  methods: {
    enroll () {
    },
    setServices () {
      this.services.payments = this.$engine.services.get()[0]
      this.services.directDebit = this.$engine.services.get()[1]
      this.services.exchangeDoc = this.$engine.services.get()[2]
      this.services.rubis = this.$engine.services.get()[3]
      this.services.diamond = this.$engine.services.get()[4]
      this.services.directPayments = this.$engine.services.get()[5]
    },
    getActiveStatus (status) {
      if (status === '1') {
        return 'Renew'
      } else {
        return 'Enroll Now !'
      }
    },
    getServiceStatus (status) {
      if (status === '1') {
        return {
          name: 'check_round_fill',
          color: 'green'
        }
      } else {
        return {
          name: 'info_fill',
          color: 'red'
        }
      }
    }
  }
}
</script>

<style scoped>
#enrollButton {
  width: 70%;
}
.serviceList {
  text-decoration: underline;
  color:black;
  font-size: 12px;
  color: blue;
}

.streammind-icon-pop-up {
  margin-left: auto !important;
}

/* TLV 28/11/2019 : Le menu "MoneyRoad services" sur PC est affiché autrement que sur mobile */
@media (max-width:992px) {
  .menuChangeService {
    padding-top:15px;
  }
}
@media (min-width:992px) {
  .menuChangeService {
    padding-top:80px;
  }
  /* TLV 09/03/2020 : Réglage de la hauteur des items du menu de changement de service */
  .menuIcon .menuItem {
    margin-top: 100px;
  }
}
</style>
